export default "__VITE_ASSET__76dc80a5__"